import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { audience } from '../../data/content';
export function AudienceSection() {
  return <section aria-labelledby="audience-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-43" data-mp="1y94wvlps811y">
      <div className="mx-auto max-w-4xl" data-id="element-44" data-mp="1t90nsgr7e8lr">
        <SectionHeading id="audience-heading" eyebrow="Built for Educators" title={<>
              This Is For You <Accent data-id="element-46" data-mp="23884ndx5cldm">If You…</Accent>
            </>} data-id="element-45" data-mp="1t87ep94rv70g" />

        <ul className="mt-12 grid gap-x-12 border-t border-brand-charcoal/12 sm:grid-cols-2" role="list" data-id="element-47" data-mp="235vl4wbqq2yg">
          {audience.map(item => <li key={item} className="flex items-start gap-3 border-b border-brand-charcoal/12 py-4 text-[15px] leading-snug text-brand-charcoal" data-id="element-48" data-mp="2cyklav1ubueh">
              <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand-cta" strokeWidth={2.25} aria-hidden="true" data-id="element-49" data-mp="2lyz7rxqjjfjk" />
              {item}
            </li>)}
        </ul>

        <p className="mt-12 text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-50" data-mp="1xafawh1hdq2d">
          Nail Educator Ready™ doesn't replace your expertise. <Accent data-id="element-51" data-mp="22c4lxwope3qg">It helps you organize and deliver it.</Accent>
        </p>
      </div>
    </section>;
}